import { css } from 'styled-components';

export const ExpandedButton = css`
  .map-expand-btn {
    position: absolute;
    z-index: 10;
    right: 10px;
    height: 37px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    box-shadow: rgba(0, 0, 0, 0.3) 0 1px 4px;

    button {
      padding: 0 10px;
      display: flex;
      min-width: 170px;
      height: 37px;
      justify-content: center;
      align-items: center;
      opacity: 0.95;
      font-size: 14px;
      font-weight: bold;
      text-align: center;
      color: #171719;
      background-color: #f9f9f9;
      border-width: 0 0 1px;
      border-left-style: initial;
      border-right-style: initial;
      border-bottom-color: rgba(0, 0, 0, 0.1);
      border-radius: 2px;
      outline: 0;
      transition: background-color 0.16s ease-out;
      cursor: pointer;

      &:hover {
        opacity: 1;
        background-color: rgb(255, 255, 255);
      }

      .lt-icons {
        margin-right: 5px;
      }
    }
  }
`;
